"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _popup_helper = _interopRequireDefault(require("../popup_helper"));
var _popupKey;
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var MlPopup = (_popupKey = /*#__PURE__*/new WeakMap(), /*#__PURE__*/function () {
  function InputPopup(source) {
    (0, _classCallCheck2["default"])(this, InputPopup);
    _classPrivateFieldInitSpec(this, _popupKey, 'ai_learning');
    this.generatePopupView(source);
  }
  return (0, _createClass2["default"])(InputPopup, [{
    key: "open",
    value: function open() {
      this.popupHelper.show(_classPrivateFieldGet(_popupKey, this));
    }
  }, {
    key: "generatePopupView",
    value: function generatePopupView(_ref) {
      var _this = this;
      var url = _ref.url,
        labels = _ref.labels,
        type = _ref.type,
        recordTime = _ref.recordTime,
        setResult = _ref.setResult;
      if (!this.popupHelper) {
        if (window.popupHelper) {
          this.popupHelper = window.popupHelper;
        } else {
          this.popupHelper = new _popup_helper["default"](true);
        }
      }
      var isPauseClicked = false;
      this.popupHelper.addPopup(_classPrivateFieldGet(_popupKey, this), {
        type: 'confirm',
        title: Lang.Blocks.learn_popup_title,
        onShow: function onShow() {
          _this.popupHelper.addClass('learning_popup');
          isPauseClicked = false;
          localStorage.setItem(_classPrivateFieldGet(_popupKey, _this), JSON.stringify({
            url: url,
            labels: labels,
            type: type,
            recordTime: recordTime
          }));
          _this.isLoading = true;
          setResult && setResult([]);
          if (Entry.engine.state == 'run') {
            Entry.engine.togglePause({
              visible: false
            });
          }
        },
        closeEvent: function closeEvent() {
          _this.isLoading = false;
          if (Entry.engine.state == 'pause' && !isPauseClicked) {
            Entry.engine.togglePause({
              visible: false
            });
          }
        },
        setPopupLayout: function setPopupLayout(popup) {
          var content = Entry.Dom('div', {
            "class": 'contentArea'
          });
          var iframe = Entry.Dom('iframe', {
            "class": "learningInputPopup ".concat(type),
            src: "/learning/popup/".concat(type)
          });
          $(iframe).on('load', function (_ref2) {
            var target = _ref2.target;
            target.contentWindow.addEventListener('message', function (_ref3) {
              var _ref3$data = _ref3.data,
                eventData = _ref3$data === void 0 ? {} : _ref3$data;
              if (typeof eventData !== 'string') {
                return;
              }
              var _JSON$parse = JSON.parse(eventData),
                key = _JSON$parse.key,
                data = _JSON$parse.data;
              if (key === 'predict') {
                setResult && setResult(data);
                _this.popupHelper.hide();
              }
              if (key === 'stop') {
                _this.popupHelper.hide();
                Entry.engine.toggleStop();
              }
              if (key === 'pause') {
                if (!isPauseClicked) {
                  isPauseClicked = true;
                  Entry.engine.togglePause({
                    visible: false
                  });
                }
                Entry.engine.togglePause();
              }
              if (key === 'error') {
                _this.popupHelper.hide();
                _this.toastError();
              }
            }, false);
          });
          content.append(iframe);
          popup.append(content);
        }
      });
    }
  }, {
    key: "toastError",
    value: function toastError() {
      Entry.toast.alert(Lang.Msgs.warn, Lang.Msgs.ai_utilize_train_pop_error, true);
    }
  }]);
}());
var _default = exports["default"] = MlPopup;